import React, { createContext, ReactChild, useReducer } from "react";
import { Logger } from "../logging/logger";

export type ProductPageTabContextType = ProductPageTabState & {
  setSelectedTabId: (tabId: string) => void;
  setSelectedTabFocus: (focusTab: boolean) => void;
};

export const ProductPageTabContext = createContext<ProductPageTabContextType>({
  selectedTabId: "",
  selectedTabFocus: false,
  setSelectedTabId: () => {},
  setSelectedTabFocus: () => {},
});

export type ProductPageTabContextProviderProps = {
  children?: ReactChild | ReactChild[] | undefined | null;
};

export interface ProductPageTabState {
  selectedTabId: string;
  selectedTabFocus: boolean;
}

export const ProductPageTabContextProvider = (props: ProductPageTabContextProviderProps) => {
  const { children } = props;
  const initialState: ProductPageTabState = {
    selectedTabId: "tab-0",
    selectedTabFocus: false,
  };
  const tabReducer = (state: ProductPageTabState, action: any) => {
    switch (action.type) {
      case "updateSelectedTabId": {
        return {
          ...state,
          selectedTabId: action.selectedTabId,
        };
      }
      case "updateSelectedTabFocus": {
        return {
          ...state,
          selectedTabFocus: action.selectedTabFocus,
        };
      }
      default: {
        Logger.instance.error("Unknown action in product page tab state", {
          actionType: action.type,
        });
        return { ...state };
      }
    }
  };
  const [state, dispatch] = useReducer(tabReducer, initialState);
  const { selectedTabId, selectedTabFocus } = state;
  const setSelectedTabId = (tabId: string) => {
    dispatch({
      type: "updateSelectedTabId",
      selectedTabId: tabId,
    });
  };
  const setSelectedTabFocus = (focusTab: boolean) => {
    dispatch({
      type: "updateSelectedTabFocus",
      selectedTabFocus: focusTab,
    });
  };

  return (
    <ProductPageTabContext.Provider
      value={{
        selectedTabId,
        selectedTabFocus,
        setSelectedTabId,
        setSelectedTabFocus,
      }}
    >
      {children}
    </ProductPageTabContext.Provider>
  );
};
